import { useSelector } from "react-redux";

// May this user edit RMS? The single frontend answer to that question —
// every RMS surface that offers a write gates on this hook rather than reading
// the flag out of redux itself (#11394).
//
// `!== false` is deliberate and load-bearing. The backend treats a user who
// belongs to no team as permitted, so an organization that does not use teams
// sends a payload where the flag is simply absent, and the flag is likewise
// absent on the first render before the sign-in payload has landed. Both mean
// "may edit"; only an explicit `false` restricts.
//
// The permission alone decides, wherever the app runs: in the full app, inside
// the Finpilot Notetaker app (#9163), and inside the frame embed (#11021),
// which was read-only until #15113 made it read-write.

// The line a withheld write shows. The topbar menu and the collection
// toolbar read it from here; the older RMS surfaces still inline the same
// sentence, so a change here has to visit them too.
export const NO_EDIT_MESSAGE =
  "Your team does not have permission to edit RMS data";

export function useCanEditRms(): boolean {
  const userData = useSelector(
    (state: { userData?: { can_edit_rms?: boolean } }) => state.userData
  );
  return userData?.can_edit_rms !== false;
}
